<template>
  <div class="video-view flex_center" @click.prevent="stopVideo">
    <div class="back phoneTop andriodTop" @click.stop="back">
      <img
        class="back-icon"
        src="@/shared/assets/image/icon/back-icon-v3.png"
        alt=""
      />
    </div>
    <video
      ref="videoRef"
      class="video"
      :class="ratio == 35 ? 'video-3-5' : 'video-9-16'"
      v-if="videoUrl"
      :src="videoUrl"
      :poster="videoUrl + defaultSnapshot"
      autoplay
      loop
      :controls="false"
      :playsinline="!isFullScreen"
      controlslist="nodownload nofullscreen noremoteplayback"
      disablePictureInPicture="true"
    ></video>
    <img
      class="play-icon"
      v-if="visibleIcon && status != 'Playing'"
      @click.stop="playVideo"
      src="@/shared/assets/image/icon/start-icon.png"
      alt=""
    />
    <div v-if="waterText" class="water-text">{{ waterText }}</div>
    <slot>
      <div class="view-footer">
        <div class="view-footer-button flex_center" @click="downloadVideo()">
          下载视频
        </div>
      </div>
    </slot>
  </div>
</template>
<script>
import { defaultSnapshot } from "@/shared/utils/index";
import { downloadWmMp4 } from "@/shared/utils/index";
export default {
  props: {
    videoUrl: {
      type: String,
      default: "",
    },
    ratio: {
      type: Number,
      default: 69,
    },
    waterText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      defaultSnapshot,
      isFullScreen: false,
      visibleIcon: true,
      status: "Paused",
    };
  },
  mounted() {
    const ua = navigator.userAgent;
    if (ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1) {
      this.isFullScreen = true; //安卓 sdk爱看环境
    } else {
      this.visibleIcon = false;
    }
    const video = this.$refs.videoRef;
    video.addEventListener("play", this.handlePlay);
    video.addEventListener("pause", this.handlePause);
  },
  beforeDestroy() {
    const video = this.$refs.videoRef;
    video.removeEventListener("play", this.handlePlay);
    video.removeEventListener("pause", this.handlePause);
  },
  methods: {
    stopVideo() {
      this.$refs.videoRef.pause();
      this.visibleIcon = true;
    },
    async downloadVideo() {
      downloadWmMp4(process.env.VUE_APP_BASE_URL, this.videoUrl).then((res) => {
        this.$wx.miniProgram.navigateTo({
          url: "/pages/file/index?url=" + encodeURIComponent(res),
        });
      });
    },
    handlePlay() {
      console.log("handlePlay");
      this.status = "Playing";
    },
    handlePause() {
      console.log("handlePause");
      this.status = "Paused";
    },
    playVideo() {
      this.$refs.videoRef.play();
    },
    back() {
      this.$emit("hideVideo");
    },
  },
};
</script>
<style lang="scss" scoped>
.view-footer {
  position: absolute;
  bottom: 40px;
  left: 0;
  right: 0;
  padding: 0 16px;
  z-index: 100;
  .view-footer-button {
    padding: 10px 0px;
    background: $bg-linear-color;
    color: #ffffff;
    font-size: 16px;
    border-radius: 12px;
    width: 70%;
    margin: 0 auto;
  }
}
/* 隐藏进度条 */
video::-webkit-media-controls-timeline,
video::-webkit-media-controls-current-time-display,
video::-webkit-media-controls-time-remaining-display {
  display: none;
}
/* 隐藏播放速度控件（仅在某些浏览器有效） */
video::-webkit-media-controls-speed-button {
  display: none !important;
}
/* 隐藏音量控件 */
video::-webkit-media-controls-volume-slider,
video::-webkit-media-controls-mute-button {
  display: none;
}

video::-internal-media-controls-download-button {
  display: none;
}
/* 针对HTML5 video标签的默认倍速按钮 */
video::-internal-media-controls-speed-button {
  display: none;
}

/* 隐藏全屏按钮 */
video::-webkit-media-controls-fullscreen-button {
  display: none;
}
.video-3-5 {
  aspect-ratio: 3 / 5;
}
.video-9-16 {
  width: 100vw;
  aspect-ratio: 9 / 16;
}
/* 针对 Firefox 隐藏进度条 */
video::-moz-progress-bar {
  display: none;
}
.play-icon {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 66px;
  height: 66px;
  z-index: 100;
}
::v-deep .video {
  object-fit: fill;
}
.video-view {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 999;
  background-color: #000;
  .video {
    position: relative;
    z-index: 1;
  }

  .back {
    position: absolute;
    top: 10px;
    left: 24px;
    height: 24px;
    width: 24px;
    z-index: 100;
    .back-icon {
      width: 100%;
      height: 100%;
    }
  }
}
.water-text {
  position: fixed;
  right: 24px;
  bottom: 16px;
  z-index: 100;
  font-size: 12px;
  color: #ffffff;
  text-shadow: 0px 0px 1.56px rgba(0, 0, 0, 0.3);
  font-family: Source Han Sans;
  opacity: 0.5;
}
</style>
